import { render, staticRenderFns } from "./DiscountTypePicker.vue?vue&type=template&id=154db59f"
import script from "./DiscountTypePicker.vue?vue&type=script&lang=js"
export * from "./DiscountTypePicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports